define('controllers/security',['require','layout'],function(require) {
    'use strict';
    var layout = require('layout');
    return {
        load: function() {
            layout.initStatic('/fe/templates/about/security');
        },
        unload: $.noop
    };
});

